<template>
	<div class="foot_copy">
		<span class="abotips portal" @click="portal">
			<img src="../assets/image/safe.png" />
			<span>京公网安备 11010802039972号</span>
		</span>
		{{ $store.state.copyNum }}
	</div>
	</div>
</template>

<script>
	export default {
		name: 'footercopy',
		data() {
			return {};
		},
		created() {},
		methods: {
			portal() {
				window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039972', '_blank')
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.portal {
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-right: 10px;

		img {
			margin-right: 4px;
		}

		// &:hover {
		// 	color: var(--brand);
		// }
	}

	.foot_copy {
		position: fixed;
		width: 100%;
		bottom: 10px;
		text-align: center;
		// color: #fff;
		z-index: 3;
		display: flex;
		justify-content: center;
	}
</style>
